/**
 * Route Icons Configuration
 *
 * Maps route codes to their corresponding icons across the application.
 * Uses a mix of Material-UI icons and custom image assets for visual representation.
 *
 * Structure:
 * - Keys: Route codes from ROUTE_CODES
 * - Values: JSX elements (either MUI icons or custom <img> tags)
 *
 * Note: Always keep in sync with ROUTE_CODES in route-codes.js
 */

import {
  AccountBalance,
  Dashboard,
  Settings,
  ViewModule,
} from "@mui/icons-material";
import CalendarToday from "@mui/icons-material/CalendarToday";
import fsToolsIcon from "../assets/images/fs-tools.png";
import suspensionManagerIcon from "../assets/images/pause.png";
import sensorManagerIcon from "../assets/images/sensor-admin.png";
import { ROUTE_CODES } from "./route-codes";

//....................................... modules icons ......................................
export const ROUTE_ICONS = {
  [ROUTE_CODES.DASHBOARD]: (
    <Dashboard className="icon icon-dashboard"></Dashboard>
  ),
  [ROUTE_CODES.SUPPORT_PLAN]: <ViewModule className="icon menu-icon" />,
  [ROUTE_CODES.SUSPENSION_MANAGER]: (
    <img
      src={suspensionManagerIcon}
      alt="FS Tools"
      className="icon menu-icon"
    />
  ),
  [ROUTE_CODES.FS_TOOLS]: (
    <img src={fsToolsIcon} alt="FS Tools" className="icon menu-icon" />
  ),
  [ROUTE_CODES.BILLING_TOOLS]: (
    <AccountBalance className="icon icon-dashboard mb-2" />
  ),
  [ROUTE_CODES.SENSOR_MANAGER]: (
    <img src={sensorManagerIcon} alt="FS Tools" className="icon menu-icon" />
  ),
  [ROUTE_CODES.SETTINGS]: <Settings className="icon menu-icon" />,
  [ROUTE_CODES.CALENDAR_VIEWER]: (
    <CalendarToday className="icon icon-calendar-viewer" />
  ),
};
